export default "__VITE_ASSET__Dekq1YEK__"